import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { ApiCallBase } from '../apiCallBase';
import { API_V3_URL } from 'src/app/config/config';
import { LanguageService } from 'src/app/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class DealManagerService extends ApiCallBase {
  correctedLanguage = 'EN-US';
  constructor(
    public languageService: LanguageService,
    public http: HttpClient,
    public router: Router,
  ) {
    super(languageService, http, router);
    this.correctedLanguage = this.language === 'es' ? 'ES-LA' : 'EN-US';
  }

  /** Get the data of one Chat Sessions from its Id
   * @param query Body of the request
   * @param token User Token for validation
   * @returns The Chat Session as an object
   */
  getUserClientSystemAssignation(
    query: GetUserClientSystemAssignation_Req,
    token: string,
  ) {
    const url = `${API_V3_URL}/deal-manager/user-clisys-assignation`;
    const queryParameters = new HttpParams({
      fromObject: query,
    });
    const apiV3Options = {
      ...this.getHttpOptionsV3WithToken(token),
      params: queryParameters,
    };

    const res = this.http
      .get<GetUserClientSystemAssignation_Res>(url, apiV3Options)
      .pipe(
        map((res) => res.response),
        catchError((error) => {
          //* If 404 then return null since it's not an actual error, just that the user have no assignation
          if (error.status == 404) {
            return of(null);
          } else {
            console.error(
              'Error retrieving a User Client System Assignation: ',
              error,
            );
            throw error;
          }
        }),
      );

    return res;
  }
}

//$ API REQUEST AND RESPONSE TYPES
//* ---- Get User Client System Assignation ----
export interface GetUserClientSystemAssignation_Req {
  user_id: string;
  [key: string]:
    string | number | boolean | readonly (string | number | boolean)[];
}

export interface GetUserClientSystemAssignation_Res {
  response: {
    deal: {
      id: string;
      name: string;
    };
    institution: {
      id: string;
      name: string;
    };
    class_list: {
      id: string;
      name: string;
      is_assigned: boolean;
      n_students: number;
      campus_name: string;
    }[];
  };
}
